export interface ILead {
  objectId?: string
  name: string
  merchant: string
  merchantPrefix: string
  customer: ILeadCustomer
  pipeline: string
  pipelineName: string
  pipelineItems: ILeadPipelineItem[]
  comments: ILeadComment[]
  activePipelineItemObjectId: string
  activePipelineItemName: string
  actor: string
  assignTo: ILeadAssignTo
  cancelAt?: Date | string
  cancelBy?: string
  distribution?: ILeadDistributionChannel
  _id?: string
  expiredAt: Date | string
  deletedAt?: Date | string
  createdAt?: Date | string
  updatedAt?: Date | string
  isFinished?: boolean
  tags: string[]
  
}

export interface ILeadPipelineItem {
  name: string
  objectId?: string
}

export interface ILeadCustomer {
  name: string
  email?: string
  facebook?: string
  phone: string
  address: string
  subDistrict: string
  district: string
  province: string
  zipcode: string
}

export interface ILeadAssignTo {
  objectId: string
  username: string
  name: string
  isAvailable: boolean
}

export interface ILeadDistributionChannel {
  type: string
  name: string
  url: string
  objectId: string
}

export interface ILeadComment {
  actor: string
  note: string
  createdAt: Date
}

export enum EExpiredDateStatus {
  EXPIRED = 'EXPIRED',
  NOT_EXPIRED = 'NOT_EXPIRED',
}

export enum ECanceledAtStatus {
  CANCELED = 'CANCELED',
  NOT_CANCELED = 'NOT_CANCELED',
}
